export { PopoverBoundariesElement as MenuBoundariesElement, PopoverLayerPosition as MenuLayerPosition } from '@doordash/component-popover';

var MenuSize;

(function (MenuSize) {
  MenuSize["Small"] = "Small";
  MenuSize["Medium"] = "Medium";
  MenuSize["Large"] = "Large";
})(MenuSize || (MenuSize = {}));

var MenuInteractionType;

(function (MenuInteractionType) {
  MenuInteractionType["ToggleClick"] = "ToggleClick";
  MenuInteractionType["Controlled"] = "Controlled";
})(MenuInteractionType || (MenuInteractionType = {}));

var MenuAlignment;

(function (MenuAlignment) {
  MenuAlignment["TopLeft"] = "TopLeft";
  MenuAlignment["BottomLeft"] = "BottomLeft";
  MenuAlignment["TopRight"] = "TopRight";
  MenuAlignment["BottomRight"] = "BottomRight";
  MenuAlignment["RightTop"] = "RightTop";
  MenuAlignment["LeftTop"] = "LeftTop";
  MenuAlignment["RightBottom"] = "RightBottom";
  MenuAlignment["LeftBottom"] = "LeftBottom";
  MenuAlignment["TopCenter"] = "TopCenter";
  MenuAlignment["BottomCenter"] = "BottomCenter";
  MenuAlignment["RightCenter"] = "RightCenter";
  MenuAlignment["LeftCenter"] = "LeftCenter";
})(MenuAlignment || (MenuAlignment = {}));

var MenuCaretDirection;

(function (MenuCaretDirection) {
  MenuCaretDirection["Up"] = "DIRECTION/UP";
  MenuCaretDirection["Down"] = "DIRECTION/DOWN";
})(MenuCaretDirection || (MenuCaretDirection = {}));

var MenuSelectType;

(function (MenuSelectType) {
  MenuSelectType["Checkbox"] = "Checkbox";
  MenuSelectType["Radio"] = "Radio";
})(MenuSelectType || (MenuSelectType = {}));

var MenuSelectPosition;

(function (MenuSelectPosition) {
  MenuSelectPosition["Leading"] = "Leading";
  MenuSelectPosition["Trailing"] = "Trailing";
})(MenuSelectPosition || (MenuSelectPosition = {}));

var MenuTitleAlignment;

(function (MenuTitleAlignment) {
  MenuTitleAlignment["Left"] = "Left";
  MenuTitleAlignment["Center"] = "Center";
  MenuTitleAlignment["Right"] = "Right";
})(MenuTitleAlignment || (MenuTitleAlignment = {}));

export { MenuAlignment, MenuCaretDirection, MenuInteractionType, MenuSelectPosition, MenuSelectType, MenuSize, MenuTitleAlignment };
